<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-dialog style="opacity: 1;" :value="showComments" width="50%" @click:outside="showCommentForm()">
      <v-card class="popup" style="overflow-y: auto; ">
        <v-toolbar dark class="v-toolbar">
          <v-toolbar-title>
            Comment Form
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showCommentForm()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <iframe :src="
          `https://us18.list-manage.com/contact-form?u=bc184f8e095ffaa20cf0a3aa7&form_id=1a2fb35814dc4e14409228ed2460cad1`
        " style="width:100%; min-height:700px;">
        </iframe>
      </v-card>
    </v-dialog>
    <v-row class="fill-height" align="center" justify="center">
      <v-col align="center" justify="center" :cols="columns">
        <!-- <v-img
          src="../../public/static/Easel Top.png"
          :width="easelTop"
          eager
        /> -->
        <div @click="toggleDialog" style="cursor:pointer">
          <v-img src="https://streetcar-east.s3.us-east-2.amazonaws.com/Public+Meeting+2+Screenshot.JPG" eager
            width="90%" />
        </div>
        <!-- <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
          eager
        /> -->
      </v-col>
      <v-col :cols="columns">
        <v-card class="slide-card" style="max-width: 90%; max-height: 85vh; overflow-y: auto;">
          <div class="slide-content">
            <h1 id="header">Share Your Thoughts</h1>
            <p>
              Thank you for visiting the Streetcar East Extension project
              website. If you have comments or questions, please let us know.
            </p>
            <p>
              <a href="https://streetcar-east.s3.us-east-2.amazonaws.com/FAQ.pdf" target="_blank">You can also access
                the project FAQs here.</a>
            </p>
            <p>
              To request this information in another language or in an
              accessible format, call 404-848-4037 or 404-848-5665 (TTY).
            </p>
            <v-row justify="center" style="padding-top: 3%;padding-bottom: 5%;">
              <v-btn color="primary" dark class="buttons" @click="showCommentForm">Provide Comment Or Question</v-btn>
            </v-row>
            <p>
              The Streetcar East Extension project team held a virtual public meeting on May 27, 2021, an in-person
              meeting on September 12, 2022, and a virtual public meeting on September 13, 2022. Both virtual meetings
              were recorded and posted on MARTA’s YouTube page. A number of questions and comments were submitted during
              the meetings and survey period. 
            </p><p>To watch the previous public meetings on MARTA’s YouTube please
                <a
                  href="https://www.youtube.com/watch?v=l9X7XDkc9GE&feature=emb_imp_woyt"
                  >click here for the meeting from 2021</a
                >
                and
                <a href="https://www.youtube.com/watch?v=aF6_OJsDcnQ"
                  >here for the recent meeting from 2022.</a>
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <ImagePopup v-if="toggled" :close-modal="toggleDialog" :image="image" />
    <!-- <YoutubeVideo :url="videoSrc" :showDialog="modalBoolean" /> -->
    <v-dialog v-model="showDialog" width="75%" height="50%" style="min-height: 55% !important;">
      <v-card>
        <v-app-bar dark color="primary" :fixed="true">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-container>
          <v-row>
            <v-col cols="12" class="text-center">
              <iframe v-if="showDialog" height="540" style="width: inherit;" :src="videoSrc" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
              </iframe>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
// import BigButton from "@/components/BigButton.vue";
import ImagePopup from "@/components/ImagePopup.vue";
// import YoutubeVideo from "@/components/YoutubeVideo.vue"

export default {
  name: "PublicComment",
  components: {
    // BigButton,
    ImagePopup
    // YoutubeVideo
  },
  data() {
    return {
      toggled: false,
      image: "tv_temp_02.png",
      modalBoolean: false,
      showDialog: false,
      //videoSrc: "https://player.vimeo.com/video/740426533?h=6aef507132",
      videoSrc: "https://www.youtube.com/embed/aF6_OJsDcnQ",
      showComments: false
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "25%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    toggleDialog() {
      this.showDialog = !this.showDialog;
    },
    showCommentForm() {
      this.showComments = !this.showComments;
    }
  }
};
</script>

<style>
.buttons {
  color: white !important;
}

.v-toolbar {
  background-color: rgb(0, 140, 204) !important;
}
</style>
